// extracted by mini-css-extract-plugin
module.exports = {"square":"Square_square__wzqWM","black":"Square_black__1FbYX","white":"Square_white__1GU5n","highlighted":"Square_highlighted__2abbj"};